var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal-dialog", {
    attrs: { disabled: _vm.disabled, label: "API", icon: _vm.$MDI.API },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v("API Command")]
        },
        proxy: true,
      },
      {
        key: "text",
        fn: function () {
          return [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$STRINGS.CURL_INTRO) +
                "\n            "
            ),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1 mb-1" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedClient,
                      expression: "selectedClient",
                    },
                  ],
                  attrs: { type: "radio", value: "curl" },
                  domProps: { checked: _vm._q(_vm.selectedClient, "curl") },
                  on: {
                    change: function ($event) {
                      _vm.selectedClient = "curl"
                    },
                  },
                }),
                _vm._v(" curl\n              "),
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedClient,
                      expression: "selectedClient",
                    },
                  ],
                  attrs: { type: "radio", value: "python" },
                  domProps: { checked: _vm._q(_vm.selectedClient, "python") },
                  on: {
                    change: function ($event) {
                      _vm.selectedClient = "python"
                    },
                  },
                }),
                _vm._v(" Python\n              "),
              ]),
            ]),
            _vm._v(" "),
            _vm.selectedClient == "curl"
              ? _c(
                  "code",
                  [
                    _vm._v("\n                curl -X POST \\"),
                    _c("br"),
                    _vm._v("\n                  -F q=@PATH_TO_FILE \\"),
                    _c("br"),
                    _vm._v(" "),
                    _vm.email
                      ? _c("span", [
                          _vm._v(
                            "\n                    -F 'email=" +
                              _vm._s(_vm.email) +
                              "' \\"
                          ),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode
                      ? _c("span", [
                          _vm._v(
                            "\n                    -F 'mode=" +
                              _vm._s(_vm.mode) +
                              "' \\"
                          ),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.taxfilter
                      ? _c("span", [
                          _vm._v(
                            "\n                    -F 'taxfilter=" +
                              _vm._s(_vm.taxfilter) +
                              "' \\"
                          ),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.database, function (path, i) {
                      return _c("span", { key: i }, [
                        _vm._v(
                          "\n                    -F 'database[]=" +
                            _vm._s(path) +
                            "'  \\"
                        ),
                        _c("br"),
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.extraParams, function (val, key) {
                      return _c("span", { key: key }, [
                        _vm._v(
                          "\n                  -F '" +
                            _vm._s(key) +
                            "=" +
                            _vm._s(val) +
                            "' \\"
                        ),
                        _c("br"),
                      ])
                    }),
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.origin() +
                            "/api/ticket" +
                            (_vm.suffix ? "/" + _vm.suffix : "")
                        ) +
                        "\n              "
                    ),
                  ],
                  2
                )
              : _c("code", { staticStyle: { "white-space": "pre-wrap" } }, [
                  _vm._v(
                    'import requests\n\nurl = "' +
                      _vm._s(
                        _vm.origin() +
                          "/api/ticket" +
                          (_vm.suffix ? "/" + _vm.suffix : "")
                      ) +
                      '"\nfile = "PATH_TO_FILE"\nwith open(file, "rb") as f:\n    files = { "q": f }\n    data = [\n'
                  ),
                  _c(
                    "span",
                    { staticStyle: { "white-space": "normal" } },
                    [
                      _vm.email
                        ? _c("span", [
                            _vm._v(
                              '        ("email", "' + _vm._s(_vm.email) + '"),'
                            ),
                            _c("br"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode
                        ? _c("span", [
                            _vm._v(
                              '        ("mode", "' + _vm._s(_vm.mode) + '"),'
                            ),
                            _c("br"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.taxfilter
                        ? _c("span", [
                            _vm._v(
                              '        ("taxfilter", "' +
                                _vm._s(_vm.taxfilter) +
                                '"),'
                            ),
                            _c("br"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.database, function (path, i) {
                        return _c("span", { key: `db-${i}` }, [
                          _vm._v(
                            '        ("database[]", "' + _vm._s(path) + '"),'
                          ),
                          _c("br"),
                        ])
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.extraParams, function (val, key) {
                        return _c("span", { key: key }, [
                          _vm._v(
                            '        ("' +
                              _vm._s(key) +
                              '", "' +
                              _vm._s(val) +
                              '"),'
                          ),
                          _c("br"),
                        ])
                      }),
                      _vm._v("\n    ]"),
                    ],
                    2
                  ),
                  _vm._v(
                    "\n    response = requests.post(url, files=files, data=data)\n    print(response.status_code)\n    print(response.json())"
                  ),
                ]),
            _vm._v(" "),
            _c("br"),
            _vm._v("\n            Refer to the "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://search.mmseqs.com/docs/",
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [_vm._v("API documentation")]
            ),
            _vm._v(
              ", on how to check the status and fetch the result.\n        "
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.showCurl,
      callback: function ($$v) {
        _vm.showCurl = $$v
      },
      expression: "showCurl",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }